import { useNavigate, useLocation } from "react-router-dom";
import { MdCheckCircle } from "react-icons/md";

export default function AppointmentSuccess() {
  const navigate = useNavigate();

  const handleBookAnother = () => {
    navigate("/book-an-appointment");
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: "linear-gradient(135deg, #f0f9ff 0%, #dbeafe 100%)",
      }}
    >
      <div
        className="bg-white rounded-3xl p-10 max-w-md w-full text-center"
        style={{
          boxShadow:
            "0 24px 64px rgba(0,173,237,0.12), 0 4px 16px rgba(0,0,0,0.06)",
        }}
      >
        {/* Icon */}
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-5"
          style={{ background: "linear-gradient(135deg, #00ADED, #006fa3)" }}
        >
          <MdCheckCircle size={40} color="white" />
        </div>

        {/* Heading */}
        <h2 className="text-2xl font-bold text-slate-800 mb-2">
          Appointment Booked Successfully!
        </h2>
        <p className="text-slate-500 text-sm mb-6 leading-relaxed">
          Your appointment has been confirmed. We'll send you a reminder soon.
        </p>

        {/* CTA Button */}
        <button
          onClick={handleBookAnother}
          className="w-full py-3.5 rounded-xl text-white font-semibold text-sm transition-all duration-300 hover:opacity-90 hover:shadow-lg"
          style={{ background: "linear-gradient(135deg, #00ADED, #006fa3)" }}
        >
          Book Another Appointment
        </button>
      </div>
    </div>
  );
}
